jQuery(document).ready(function($) {

	//////////////////////////////////////////////////////////////
	// ORDER ONLINE MODALS
	//////////////////////////////////////////////////////////////

	const ooModalShow = (modal) => {
		$(modal).modal('show');

		// removes the ptt form in sidebar as there can only be one per page
		let pttForm = document.getElementById('stoked-pickup-sidebar');
		if (pttForm != null) {
			pttForm.remove();
		}
	};


	// show Order Online modal if not seen today
	const ooModal = document.getElementById('modal--order-online');
	if (ooModal) {
	
		// if cookie not set with today's date, then show modal
		if (Cookies.get('stoked_ooModal') != undefined) {
			let now = new Date();
	
			let cookieDate = new Date(Cookies.get('stoked_ooModal'));
			if (cookieDate.getDate() != now.getDate() || cookieDate.getYear() != now.getYear()) {
				ooModalShow(ooModal);
			}

		// if not set at all, then show modal
		} else {
			ooModalShow(ooModal);
		}

		// show modal for testing with query parameter
		let params = new URLSearchParams(window.location.search);
		if (params.get('popup') == 'true') {
			ooModalShow(ooModal);
		}			

	  var currentDate = new Date();
    Cookies.set('stoked_ooModal', currentDate);
  }
 
});